import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/F1_Mode_protection_timer.svg"

const F1Modeprotectiontimer: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 76 76'} component={Icon} {...props} fill="currentColor" />
export default F1Modeprotectiontimer
